import { types } from "mobx-state-tree";

const FeeSchedule = types.model({
  id: types.maybe(types.number),
  name: types.maybe(types.string)
});

export default FeeSchedule;
